module.exports = __webpack_public_path__ + "img/12-5.c9b3cf27.png";